<template>
  <div class="container">
  <ol class="breadcrumb">
    <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
    <li class="active">Sandbox</li>
  </ol>

  <h4>Analysis Verdicts</h4>

  <div class="row">
    <div class="col-md-12">
      <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>SHA1 Checksum</th>
            <th>Size</th>
            <th>Processing State</th>
            <th>Classification</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(verdict, index) in verdictsSorted" v-bind:class="tableRowStyle(verdict.classification)" data-toggle="collapse" v-bind:data-target="'#details' + index" class="accordion-toggle">
            <td>{{ epochDate(verdict.timestamp) }}</td>
            <td><router-link :to="{ name: 'SandboxRecord', params: { sha1: verdict.sha1Checksum, size: verdict.size }}">{{ verdict.sha1Checksum }}</router-link></td>
            <td>{{ verdict.size }}</td>
            <td>{{ verdict.processingState }}</td>
            <td>{{ verdict.classification }}</td>
            <td><a v-bind:href="graywareDownloadLink(verdict.sha1Checksum, verdict.size)" v-bind:download="graywareDownloadFilename(verdict.sha1Checksum, verdict.size)"><span class="glyphicon glyphicon-download" aria-hidden="true"></span></a></td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</div>
</template>

<style scoped>
</style>

<script>
import _ from 'underscore'
import moment from 'moment'
import * as mutationTypes from '../store/mutation-types'

export default {
  data () {
    return {
      epochStart: moment().subtract(30, 'days').format('x'),
      epochEnd: moment().format('x'),
      verdicts: []
    }
  },

  mounted () {
    this.$store.commit(mutationTypes.LOADER_LOADING)
    this.$apiSandbox.fetchVerdicts(this.epochStart, this.epochEnd)
    .then((result) => {
      // console.log('got', result)
      this.$store.commit(mutationTypes.LOADER_NOT_LOADING)
      this.verdicts = result
    })
  },

  computed: {
    verdictsSorted () {
      return _.sortBy(this.verdicts, 'timestamp').reverse()
    }
  },

  methods: {
    epochDate (epoch) {
      return moment(epoch, 'x').format('YYYY-MM-DD')
    },
    tableRowStyle (classification) {
      var styles = {
        CLEAN: 'success',
        APT: 'danger',
        UNKNOWN: ''
      }
      if (!(classification in styles)) {
        return ''
      }

      return styles[classification]
    },

    graywareDownloadLink (sha1Checksum, size) {
      return this.$apiSandbox.graywareDownloadLink(sha1Checksum, size)
    },

    graywareDownloadFilename (sha1Checksum, size) {
      return sha1Checksum + '-' + size + '.dat'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Sandbox.vue?952d1096